/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Bug(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M167.92969,92a12,12,0,1,1-12-12A12,12,0,0,1,167.92969,92Zm-68-12a12,12,0,1,0,12,12A12,12,0,0,0,99.92969,80ZM252,128a8.00039,8.00039,0,0,1-8,8H216v8a87.78437,87.78437,0,0,1-3.24438,23.69629l23.16723,13.37549a8,8,0,1,1-8,13.85644l-20.96533-12.104a87.9757,87.9757,0,0,1-157.915,0l-20.96533,12.104a8,8,0,1,1-8-13.85644l23.16723-13.37549A87.78437,87.78437,0,0,1,40,144v-8H12a8,8,0,0,1,0-16H40v-8a87.787,87.787,0,0,1,3.24438-23.69629L20.07715,74.92822a8,8,0,0,1,8-13.85644L49.04248,73.17627a87.97531,87.97531,0,0,1,157.915,0l20.96533-12.10449a8,8,0,0,1,8,13.85644L212.75562,88.30371A87.787,87.787,0,0,1,216,112v8h28A8.00039,8.00039,0,0,1,252,128ZM136,144a8,8,0,0,0-16,0v64a8,8,0,0,0,16,0Zm64-32a72,72,0,0,0-144,0v8H200Z" />
    </Svg>
  );
}

export default Bug;
